'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.readUrlPart = readUrlPart;
exports.getWebcomponentsUrl = getWebcomponentsUrl;
exports.setLinePricesFromTransportPassengerAssignments = setLinePricesFromTransportPassengerAssignments;
exports.setLinePricesFromPriceSelections = setLinePricesFromPriceSelections;
exports.getUnitPriceForSelection = getUnitPriceForSelection;
exports.getReservablePriceForSelection = getReservablePriceForSelection;
exports.findImage = findImage;
exports.producerImage = producerImage;
exports.destinationImage = destinationImage;
exports.formatDateRange = formatDateRange;
exports.trump = trump;
exports.getReservationLink = getReservationLink;
exports.getReservationLinkWithWPMLAndSeo = getReservationLinkWithWPMLAndSeo;
exports.langParameterExist = langParameterExist;
exports.getLog = getLog;
exports.removeSpecialChars = removeSpecialChars;
exports.clearWhiteSpace = clearWhiteSpace;
exports.removeHTMLTags = removeHTMLTags;
exports.getFlatTree = getFlatTree;
// asdf.html#/first/something -> this call with 0 returns 'first', 
// with 1 returns 'something'.
// I.e. reads data from location hash when Angular router is not used (reservation
// components don't use it, as not to interfere with other angular tc. instances on the site.)
function readUrlPart($location, index) {
    var path = $location.path();
    if (path[0] == '/') path = path.substr(1);
    if (path == "") return null;
    path = path.split('/');
    return path.length > index ? path[index] : null;
}

// /path.html => https://varaamo.matkaverkko.fi/webcomponents/1.0/assets/path.html
function getWebcomponentsUrl(path) {
    if (path.match(/^https?:\/\//)) {
        return path;
    } else {
        return __webpack_public_path__ + '/' + path;
    }
}

function setLinePricesFromTransportPassengerAssignments(line) {
    if (!line.PassengerAssignments || line.PassengerAssignments.length === 0) {
        // If no passenger assignments exist, do nothing.
        return;
    }

    // Don't bother even trying to set the unit price.
    // In principle, it could be set if all the selected stops have the same price.
    // Not sure if that would provide any benefit, though.
    line.UnitPrice = null;

    line.TotalPrice = _.sumBy(line.PassengerAssignments, function (pa) {
        return pa.Price;
    });
}

function setLinePricesFromPriceSelections(line) {
    if (!line.PriceSelections || line.PriceSelections.length === 0) {
        // If no price selections exist, do nothing.
        return;
    }

    // If this is a new-style service, we'll have an easier time.
    if (line.IsService) {
        line.UnitPrice = null;
        line.TotalPrice = _.sumBy(line.PriceSelections, function (ps) {
            return ps.Amount * ps.WS_UnitPrice;
        });
        return;
    }

    var reservablePrices = getReservablePrices(line);

    // If there is only one selected price, we can set the unit price based on that.
    // If there are multiple selected prices, there is no valid single unit price.
    line.UnitPrice = line.PriceSelections.length === 1 ? getUnitPriceForSelection(line.PriceSelections[0], reservablePrices) : null;

    line.TotalPrice = _.sumBy(line.PriceSelections, function (sel) {
        return sel.Amount * getUnitPriceForSelection(sel, reservablePrices);
    });
}

function getReservablePrices(line) {
    if (line.Product && line.Product.ReservablePrices) {
        return line.Product.ReservablePrices;
    } else {
        // Can't calculate without this information.
        console.error('Line has no ReservablePrices:', line);
        throw new Error('Line has no ReservablePrices.');
    }
}

function getUnitPriceForSelection(selection, reservablePrices) {
    var price = getReservablePriceForSelection(selection, reservablePrices);
    return price && price.Price;
}

function getReservablePriceForSelection(selection, reservablePrices) {
    return _.find(reservablePrices, function (price) {
        return price.Index === selection.PriceIndex;
    });
}

function findImage(p) {
    return producerImage(p) || destinationImage(p) || null;
}

function producerImage(p) {
    return p && p.Producer && p.Producer.Images && p.Producer.Images[0] && p.Producer.Images[0].Url;
}

function destinationImage(p) {
    return p && p.DestinationInfo && p.DestinationInfo.Images && p.DestinationInfo.Images[0];
}

function formatDateRange(beginDate, endDate) {
    var begin = moment(beginDate);
    var end = moment(endDate);

    var firstPart = formatBeginDate(begin, end);
    var secondPart = end.format('D.M.YYYY');
    if (firstPart) {
        return firstPart + '–' + secondPart;
    } else {
        return secondPart;
    }
}

function formatBeginDate(begin, end) {
    if (begin.isSame(end, 'day')) {
        return null;
    } else if (begin.isSame(end, 'month')) {
        return begin.format('D.');
    } else if (begin.isSame(end, 'year')) {
        return begin.format('D.M.');
    } else {
        return begin.format('D.M.YYYY');
    }
}

function trump(str, pattern) {
    var trumped = "";

    if (str && str.length) {
        trumped = str;
        if (pattern && pattern.length) {
            for (var i = 0; i < pattern.length; i++) {
                var idx = str.toLowerCase().indexOf(pattern[i]);

                if (idx != -1) {
                    trumped = str.substring(0, idx);
                }
            }
        }
    }
    return trumped;
}

// FIXME
function getReservationLink(ctrl, result) {
    var template = ctrl.reservationLinkTemplate;
    var ReservationLink = template;

    if (template != "") {
        var currentUrl = window.location.href;
        if (currentUrl.indexOf('?') != -1) {
            currentUrl = trump(currentUrl, '?');
        }

        if (template != null && template.indexOf('http') === -1) {
            if (template.indexOf('../') !== -1) {
                var s = currentUrl;
                s = s.substring(0, s.lastIndexOf("/"));
                template = s.substring(0, s.lastIndexOf("/")) + template.substring(2, template.length);
            } else {
                if (currentUrl.lastIndexOf(template) == -1) template = currentUrl + template;else template = currentUrl;
            }
        }

        if (ctrl.useSeoLinks) {
            if (result.Departure == null && ctrl.noDatesForDayCapacity === 'true') {
                ReservationLink = template + '/#!/' + result.Destination.DestinationName.replaceAll(" ", "-").replaceAll("/", "") + '/' + result.Destination.DestinationCode + '///2';
            } else {
                var isDeparture = !(result.Departure == null && ctrl.noDatesForDayCapacity !== 'true');
                ReservationLink = template + '/#!/' + result.Destination.DestinationName.replaceAll(" ", "-").replaceAll("/", "").replaceAll("ä", "a").replaceAll("ö", "o").replaceAll("å", "a") + (isDeparture ? '/departure/' : '/') + (isDeparture ? result.Departure.DestinationCode : result.Destination.DestinationCode) + '/' + ctrl.$filter('date')(isDeparture ? result.Departure.DepartureDate : result.StartDate, 'yyyy-M-d') + '/' + ctrl.$filter('date')(isDeparture ? result.Departure.ArrivalDate2 : result.EndDate, 'yyyy-M-d') + '/' + ctrl.searchCriteria.NumAdults + '/' + ctrl.searchCriteria.NumChildren + '/' + ctrl.searchCriteria.NumInfants;
            }
        } else {
            if (result.Departure == null && ctrl.noDatesForDayCapacity === 'true') {
                ReservationLink = template + '/#!/' + result.Destination.DestinationCode + '///2' /*+'/'+ctrl.$filter('date')(result.Destination.DepartureDate, 'yyyy-M-d')+'/'+ctrl.$filter('date')(result.Destination.ArrivalDate2, 'yyyy-M-d')+'/'+ctrl.searchCriteria.NumAdults+'/'+ctrl.searchCriteria.NumChildren+'/'+ctrl.searchCriteria.NumInfants*/;
            } else if (result.Departure == null && ctrl.noDatesForDayCapacity !== 'true') {
                ReservationLink = template + '/#!/' + result.Destination.DestinationCode + '/' + ctrl.$filter('date')(result.StartDate, 'yyyy-M-d') + '/' + ctrl.$filter('date')(result.EndDate, 'yyyy-M-d') + '/' + ctrl.searchCriteria.NumAdults + '/' + ctrl.searchCriteria.NumChildren + '/' + ctrl.searchCriteria.NumInfants;
            } else {
                ReservationLink = template + '/#!/departure/' + result.Departure.DestinationCode + '/' + ctrl.$filter('date')(result.Departure.DepartureDate, 'yyyy-M-d') + '/' + ctrl.$filter('date')(result.Departure.ArrivalDate2, 'yyyy-M-d') + '/' + ctrl.searchCriteria.NumAdults + '/' + ctrl.searchCriteria.NumChildren + '/' + ctrl.searchCriteria.NumInfants;
            }
        }
    }

    /*
    *  Make reservations links (links to products page in the listing)
    *  compatible with Wordpress multilingual plugin WPML
    *  it need the ?lang=XX parameter added.
    *  (WPML can also be configured to use subfolder example.com/XX/content format)
    * */
    //Check if WPML is enabled
    try {
        if (document.querySelector("meta[name=generator][content^='WPML']")) {
            // Check for if ?lang parameter exist in the different language versions
            // We can assume that the ?lang=XX URL scheme for WPML is in use
            // Otherwise we assume the /[LANGCODE]/ scheme and don't need to add ?lang= to URL
            if (Array.from(document.querySelectorAll("link[rel=alternate]")).some(langParameterExist)) {
                //Check if this has already run, or that ?lang= is not already otherwise present
                if (ReservationLink.indexOf("?lang=") == -1) {
                    var reservationLinkBasePart = ReservationLink.split('#')[0];
                    var reservationLinkEndPart = "#" + ReservationLink.split('#')[1];
                    var langParameter = "?lang=";
                    var langCode = ctrl.localizationService.getLanguage();
                    var reservationLinkWithLang = reservationLinkBasePart + langParameter + langCode + reservationLinkEndPart;
                    ReservationLink = reservationLinkWithLang;
                    //console.log("added lang to reservation link: " + ReservationLink + " --> " + reservationLinkWithLang);
                }
            }
        }
    } catch (e) {
        console.log("ERROR2");console.error(e);
    }

    return ReservationLink;
}

// const WPML = document.querySelector("meta[name=generator][content^='WPML']");
// const SEO = this.winresReservationContext.getSeoState();
// const language = this.localizationService.getLanguage();
// template = 'kohde'

// Get reservation link with seo (destination name) and wpml (?lang=)
// Deprecated, as backend should handle SEO and WPML link generation
// TODO: Rename to getReservationLink
function getReservationLinkWithWPMLAndSeo(template, destName, destCode, startDate, endDate, language, numAdults, numChildren, numInfants, noDates, seo, wpml, departure) {
    numAdults = numAdults || 2;
    numChildren = numChildren || 0;
    numInfants = numInfants || 0;

    var split = window.location.pathname.split('/');

    // /wp-template/majoitus/
    // --> /wp-template/
    if (split.length === 4) {
        split.splice(2, 1);
    }

    // /wp-template/
    // --> /wp-template
    var pathName = split.join('/');
    pathName = pathName.substring(0, pathName.length - 1);

    var url = pathName === '/kohde' || pathName === '/destination' ? window.location.origin : window.location.origin + pathName;

    if (noDates) {
        startDate = '';
        endDate = '';
    }

    var linkParts = [url, template, wpml ? '?lang=' + language + '#!' : '#!', removeSpecialChars(destName), 'departure', destCode, startDate, endDate, numAdults, numChildren, numInfants];

    if (!departure) {
        linkParts.splice(4, 1);
    }

    if (!seo) {
        linkParts.splice(3, 1);
    }

    return linkParts.join('/');
}

function langParameterExist(element) {
    if (element.href.indexOf("?lang=") != -1) {
        return true;
    }
}

function getLog(tag) {
    var withTag = function withTag(fmt) {
        return tag + ' ' + fmt;
    };
    var log = function log(fmt) {
        var _console;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return (_console = console).log.apply(_console, [withTag(fmt)].concat(args));
    };
    log.warn = function (fmt) {
        var _console2;

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
        }

        return (_console2 = console).warn.apply(_console2, [withTag(fmt)].concat(args));
    };
    log.warning = log.warn;
    log.error = function (fmt) {
        var _console3;

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
        }

        return (_console3 = console).error.apply(_console3, [withTag(fmt)].concat(args));
    };
    return log;
}

function removeSpecialChars(string) {
    if (string === null) return null;
    if (string === undefined) return undefined;
    return string.toLowerCase().replaceAll(' ', '-').replaceAll('/', '').replaceAll('ä', 'a').replaceAll('ö', 'o').replaceAll('å', 'a').replaceAll('ø', 'o').replaceAll('ß', 's').replaceAll('\\*', '');
}

function clearWhiteSpace(string) {
    return string ? string.replace(/ /g, '') : string;
}

// Remove HTML tags.
function removeHTMLTags(string) {
    return string.replace(/<[^>]*>/g, '');
}

function getFlatTree(level) {
    return function (result, object) {
        var children = object.Children || [],
            item = Object.keys(object).reduce(function (o, k) {
            if (k !== 'Children') o[k] = object[k];
            return o;
        }, {});

        level = level || 0;
        item.level = level;
        return result.concat(item, children.reduce(getFlatTree(level + 1), []));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/utils.js
// module id = 33
// module chunks = 0 2